import React, { createRef } from "react";
import { InputFactory, InputJson } from "nq-component";
import BaseFormPage from "../../../../../base/BaseFormPage";
import {
  deleteObjectUseCase,
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import OfficeFormPresenter from "../../../../OrganizationaStructure/offices/office-form/OfficeFormPresenter";
import NavBar from "../../../../../components/navigation";
import withRouter from "../../../../../withRouter";
import ViewListOfEmployee from "./ViewListOfEmployee";
import CardView from "../../../../../components/common/CardView";
import SearchSelect from "../../../../../components/searchSelect/SearchSelect";
import {
  FloatingForm,
  SubmitImg,
} from "../../../../../components/common/Converter";
import FileUpload from "../../../../../components/common/FileUpload";
import { createNotification } from "../../../../../createNotification";

class ListOfEmployeeForm extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      isCommendationOpen: false,
      title: "",
      description: "",
      type: "",
      objectID: "",
      isDisabled: false,
      oldtitle: "",
      olddescription: "",
      oldtype: "",
      newObj: {},
      selectedFiles: [],
    };
    this.presenter = new OfficeFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
    this.childRef = createRef();
  }

  // async componentDidUpdate(prevProps, prevState) {
  //   if (prevState.object !== this.state.object) {
  //     // await this.fetchListOfEmployee();
  //     this.setState({ source: this.state.object });
  //   }
  // }
  // componentDidMount() {
  //   this.presenter.componentDidMount();
  //   this.setState({ source: this.state.object });
  // }

  // async fetchListOfEmployee() {
  //   const { object } = this.state;
  //   const employee = `${object.Firstname} ${object.Middlename} ${object.surname}`;
  //   const query = {
  //     where: {
  //       employee: employee,
  //     },
  //   };
  //   const viewCommendation = await findObjectUseCase().execute(
  //     "commendation_list",
  //     query
  //   );
  //   this.setState({ viewCommendation });
  // }

  getCollectionName() {
    return "employees";
  }
  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  handleCommendation() {
    this.setState({
      isCommendationOpen: true,
      title: "",
      description: "",
      selectedFiles: [],
      type: "",
      objectID: "",
      isDisabled: false,
    });
  }

  onReceiveData(object) {
    this.handleCommendation();
    this.setState({
      type: object.type,
      title: object.title,
      selectedFiles: object.selectedFiles,
      description: object.description,
      objectID: object.id,
      newObj: object,
    });
  }

  async onViewData(id) {
    const object = await findObjectUseCase().execute("commendation_list", {
      where: { id: id },
    });
    this.setState({
      type: object[0].type,
      title: object[0].title,
      selectedFiles: object[0].selectedFiles,
      description: object[0].description,
      isCommendationOpen: true,
      isDisabled: true,
    });
  }

  inputChange = (field) => (value) => {
    if (this.state.objectID !== "") {
      this.setState({
        [field]: value,
        [`old${field}`]: this.state.newObj[field],
      });
    } else {
      this.setState({ [field]: value });
    }
  };

  handleFileChange(selectedFiles) {
    this.setState({ selectedFiles });
  }

  async handleSaveCommendation() {
    const { title, description, type, objectID, object, selectedFiles } =
      this.state;
    if (selectedFiles.length === 0) {
      this.showError("Attachment Required");
      return;
    }

    const file = await SubmitImg(selectedFiles);

    const data = {
      type,
      title,
      description,
      employeeID: object.id,
      employee: `${object?.Firstname} ${object?.Middlename || ""} ${
        object?.surname
      }`,
      selectedFiles: file,
    };
    if (objectID !== "") {
      const update = {
        ...data,
        id: objectID,
      };
      this.inserData(update);
      const logs = {
        ...data,
        title: [],
        action: "UPDATE",
      };

      // Array of field names to check
      const fields = ["type", "title", "description"];

      fields.forEach((field) => {
        const oldField = this.state[`old${field}`];
        if (oldField && oldField !== update[field]) {
          logs.title.push(
            `${field.charAt(0).toUpperCase() + field.slice(1)}: ${oldField} - ${
              update[field]
            }`
          );
        }
      });

      if (logs.title.length > 0) {
        upsertUseCase().execute("commendation_logs", logs);

        //  CREATE NOTIFICATION
        const NOTIFICATION_MESSAGE =
          "A new entry has been added to your Commendation Logs.";
        const NOTIFICATION_RECEIVER = ["role:Supervisor", "role:Super Admin"];
        const NOTIFICATION_REDIRECT = "commendation";

        createNotification(
          NOTIFICATION_MESSAGE,
          NOTIFICATION_RECEIVER,
          NOTIFICATION_REDIRECT
        );
      }
    } else {
      await this.inserData(data);
      const logs = {
        ...data,
        title: [`Title: ${data.title}`],
        action: "CREATE",
      };
      upsertUseCase().execute("commendation_logs", logs);

      //  CREATE NOTIFICATION
      const NOTIFICATION_MESSAGE =
        "A new entry has been added to your Commendation Logs.";
      const NOTIFICATION_RECEIVER = ["role:Supervisor", "role:Super Admin"];
      const NOTIFICATION_REDIRECT = "commendation";

      createNotification(
        NOTIFICATION_MESSAGE,
        NOTIFICATION_RECEIVER,
        NOTIFICATION_REDIRECT
      );
    }
  }
  async inserData(data) {
    const commendation = upsertUseCase().execute("commendation_list", data);
    const NOTIFICATION_MESSAGE =
      "You have a new commendation in the Commendation List";
    const NOTIFICATION_RECEIVER = [commendation.employeeID];
    const NOTIFICATION_REDIRECT = "accomplishments";

    createNotification(
      NOTIFICATION_MESSAGE,
      NOTIFICATION_RECEIVER,
      NOTIFICATION_REDIRECT
    );

    this.setState({ isCommendationOpen: false });
    if (this.childRef.current) {
      this.childRef.current.refetchData();
    }
    this.showSuccess("Successfully saved!");
  }

  render() {
    const object = this.state.object;
    const advanced = this.state.advanced;

    console.log("object", object);
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100 mt-5">
            <div className="p-lg-4">
              <div className="bg-white shadow rounded p-3">
                <div className="row">
                  {advanced ? (
                    <InputJson
                      defaultValue={object}
                      onChange={this.onChangeObject.bind(this)}
                      rows="15"
                    />
                  ) : (
                    <>
                      <div className="p-0">
                        <div className="p-3">
                          <h3 className="text-primary">
                            List of my Recommendations
                          </h3>
                          <blockquote className="blockquote">
                            <h6>
                              First Name: <b>{object.Firstname}</b>
                            </h6>
                            <h6>
                              Middle Name: <b>{object.Middlename}</b>
                            </h6>
                            <h6>
                              Last Name: <b>{object.surname}</b>
                            </h6>
                          </blockquote>
                          <div className="d-flex justify-content-end">
                            <button
                              className="btn btn-primary"
                              onClick={this.handleCommendation.bind(this)}
                            >
                              <i className="bi bi-plus" /> Create Commendation
                            </button>
                          </div>
                        </div>

                        <hr />
                        {Object.keys(object).length > 0 && (
                          <ViewListOfEmployee
                            source={object}
                            ref={this.childRef}
                            onReceiveData={this.onReceiveData.bind(this)}
                            onViewData={this.onViewData.bind(this)}
                          />
                        )}
                      </div>
                    </>
                  )}
                </div>
                <button
                  onClick={() => this.navigateBack()}
                  className="btn btn-primary mt-3"
                >
                  {" "}
                  <i className="bi bi-arrow-left"></i>Back
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.state.isCommendationOpen && (
          <>
            <FloatingForm width="30rem">
              <CardView style={{ padding: 0 }}>
                <h4 className="fs-6 fw-bold pt-3 ps-3">Commendation Details</h4>
                <hr />
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.handleSaveCommendation();
                  }}
                >
                  <div className="w-100 pt-3" style={{ padding: "0 1.5rem" }}>
                    <div className="mb-4">
                      <label className="mb-2">
                        Type <span className="text-danger">*</span>
                      </label>
                      <SearchSelect
                        required
                        value={this.state.type}
                        onChange={this.inputChange("type")}
                        onClickClear={() => this.setState({ type: "" })}
                        disabled={this.state.isDisabled}
                        options={["Good", "Bad"].map((stats) => ({
                          label: stats,
                          value: stats,
                        }))}
                      />
                    </div>
                    <div className="mb-4">
                      {["Title", "Description"].map((label, index) => (
                        <>
                          <label className="mb-2" key={index}>
                            {label} <span className="text-danger">*</span>
                          </label>
                          <div className="col-lg-12 mb-4">
                            <InputFactory
                              required
                              type={label === "Title" ? "String" : "Text"}
                              value={this.state[label.toLowerCase()]}
                              disabled={this.state.isDisabled}
                              onChange={(value) =>
                                this.inputChange(label.toLowerCase())(value)
                              }
                            />
                          </div>
                        </>
                      ))}

                      <div className="d-grid">
                        <label className="mb-2">
                          File Attachment <span className="text-danger">*</span>
                        </label>
                        <FileUpload
                          label={"Upload Attachments"}
                          attachments={this.state.selectedFiles}
                          disabled={this.state.isDisabled}
                          onFileChange={this.handleFileChange.bind(this)}
                        />
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                    <button
                      className="btn btn-light"
                      type="button"
                      onClick={() =>
                        this.setState({ isCommendationOpen: false })
                      }
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      // onClick={this.handleSaveCommendation.bind(this)}
                      type="submit"
                      style={{ display: this.state.isDisabled ? "none" : "" }}
                    >
                      Save
                    </button>
                  </div>
                </form>
              </CardView>
            </FloatingForm>
          </>
        )}
      </>
    );
  }
}

export default withRouter(ListOfEmployeeForm);
